import { createContext, useEffect, useState } from "react";

const cartPersisted = JSON.parse(localStorage.getItem("cart"));

const cartContextInitalValue = cartPersisted ? cartPersisted : {};

const CartContext = createContext(cartContextInitalValue);

const CartContextProvider = ({ children }) => {
  const [cart, setCart] = useState(cartContextInitalValue);
  const [cartSubtotal, setCartSubTotal] = useState(0);
  const [cartItemsQuantity, setCartItemsQuantity] = useState(0);
  const [cartShippingType, setCartShippingType] = useState(null);
  const [cartShippingPrice, setCartShippingPrice] = useState(0);

  useEffect(() => {
    __calcCartSubTotalPrice(cartContextInitalValue);
    __calcCartItemsQuantity(cartContextInitalValue);
  }, []);

  const updateCart = (newCart) => {
    localStorage.setItem("cart", JSON.stringify(newCart));
    __calcCartSubTotalPrice(newCart);
    __calcCartItemsQuantity(newCart);
    setCart({ ...newCart });
  };

  const addCartItem = (item) => {
    const clonedCart = { ...cart };
    if (clonedCart.hasOwnProperty(item.id)) {
      clonedCart[item.id].toy = item;
      clonedCart[item.id].quantity += 1;
    } else {
      clonedCart[item.id] = {
        toy: item,
        quantity: 1,
      };
    }
    updateCart(clonedCart);
  };

  const removeCartItem = (item) => {
    const clonedCart = { ...cart };
    delete clonedCart[item.id];
    updateCart(clonedCart);
  };

  const decreaseCartItemQuantity = (toyId) => {
    const clonedCart = { ...cart };
    clonedCart[toyId].quantity -= 1;
    updateCart(clonedCart);
  };

  const removeAllCartItems = () => {
    updateCart({});
  };

  const __calcCartItemsQuantity = (newCart) => {
    const sum = Object.keys(newCart).reduce((a, key) => {
      return a + newCart[key].quantity;
    }, 0);
    setCartItemsQuantity(sum);
  };

  const __calcCartSubTotalPrice = (newCart) => {
    const sum = Object.keys(newCart).reduce((a, key) => {
      return a + newCart[key].toy.selectedRental.value * newCart[key].quantity;
    }, 0);
    setCartSubTotal(sum);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addCartItem,
        removeCartItem,
        decreaseCartItemQuantity,
        cartSubtotal,
        removeAllCartItems,
        cartItemsQuantity,
        cartShippingType,
        setCartShippingType,
        cartShippingPrice,
        setCartShippingPrice
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export { CartContext, CartContextProvider, cartContextInitalValue };
